import { render, staticRenderFns } from "./RecentCalls.vue?vue&type=template&id=4a7489ea&scoped=true"
import script from "./RecentCalls.vue?vue&type=script&lang=js"
export * from "./RecentCalls.vue?vue&type=script&lang=js"
import style0 from "./RecentCalls.vue?vue&type=style&index=0&id=4a7489ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7489ea",
  null
  
)

export default component.exports